import { useState, useEffect } from "react";
import TyltLogo from "@assets/logos/tylt_logo.png";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import Logout from "@assets/icons/logout.svg";
import secureLocalStorage from "react-secure-storage";
import LogoutSlidingPanel from "@components/sliders/LogoutSlidingPanel";

const Layout = ({ initialSelectedTab }) => {
  const navigate = useNavigate();
  const [isLogout, setIsLogout] = useState<boolean>(false);
  const location = useLocation();
  const currentPath = location.pathname;

  const getSelectedTab = (path: string) => {
    if (path === "/") return "refund_management";
    return "";
  };

  const [selectedTab, setSelectedTab] = useState(getSelectedTab(currentPath));

  useEffect(() => {
    setSelectedTab(getSelectedTab(currentPath));
  }, [currentPath]); // Update selectedTab when path changes

  return (
    <div className="flex flex-row min-h-screen min-w-screen">
      <div className="w-[100px] border-r border-r-border-subtle px-[25px] bg-bg-trx-card-header flex flex-col items-center gap-[20px]">
        {/* Tylt Logo */}
        <img src={TyltLogo} alt="Logo" className="object-contain my-[25px]" />

        {/* Refund Management */}
        <div
          className={`flex flex-col items-center justify-center rounded-lg py-[8px] w-[90px] cursor-pointer space-y-[4px] ${
            selectedTab === "refund_management"
              ? "bg-bg-page-body"
              : "bg-bg-trx-card-header"
          }`}
          onClick={() => navigate("/")}
        >
          <span className="font-semibold text-[12px] text-text-base leading-none text-center">
            Refund Management
          </span>
        </div>

        <img
          src={Logout}
          alt=""
          className="mt-auto mb-4 bg-bg-page-body p-2 rounded-2xl cursor-pointer"
          onClick={() => {
            setIsLogout(true);
          }}
        />
      </div>

      <div className="flex flex-col" style={{ width: "calc(100dvw - 100px)" }}>
        {/* Main Content */}
        <div className="flex-grow">
          <LogoutSlidingPanel
            isOpen={isLogout}
            onClose={() => setIsLogout(false)}
            type="send"
            onClickConfirm={() => {
              secureLocalStorage.clear();
              navigate("/login");
            }}
            sliderHeading="Logout"
          />
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Layout;
